import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";
import Users from "../components/admin/Users";
import Outfitters from "../components/admin/Outfitters";
import RiverSections from "../components/admin/RiverSections";
import Rivers from "../components/admin/Rivers";
import Settings from "../components/dashboard/Settings";
import Pricing from "../components/dashboard/Pricing";
import Discounts from "../components/dashboard/Discounts";
import PriceGroups from "../components/dashboard/PriceGroups";
import DisplayGroups from "../components/dashboard/DisplayGroups";
import Slideshows from "../components/dashboard/Slideshows";
import PendingOrders from "../components/dashboard/PendingOrders";
// import Uploader from "@/components/photographer/Uploader";
import DashboardRivers from "@/components/dashboard/DashboardRivers";
import Search from "@/components/outfitter/Search";
import Cart from "@/components/cart/Cart";
import Counter from "@/components/deliver/Counter";
import Order from "@/components/deliver/Order";
import OrderDetail from "@/components/dashboard/OrderDetail";
import DashboardUsers from "@/components/dashboard/DashboardUsers";
import Closing from "../components/dashboard/reports/Closing";
import Full from "../components/dashboard/reports/Full";
import Albums from "../components/admin/Albums";
import Orders from "../components/admin/Orders";
import Photographer from "../components/admin/reports/Photographer";
import Comprehensive from "../components/admin/reports/Comprehensive";
import Zip from "../components/deliver/Zip";

Vue.use(VueRouter);

const ifAuthenticated = (to, from, next) => {
  if (store.getters["auth/isAuthenticated"]) {
    next();
  } else {
    next("/login");
  }
};

const routes = [
  {
    path: "/slideshow",
    name: "slideshow",
    component: () =>
      import(/* webpackChunkName: "slideshow" */ "../views/Slideshow.vue"),
    children: [
      {
        path: ":slideshowId",
        component: () =>
          import(
            /* webpackChunkName: "slideshow" */ "../components/public/Slideshow.vue"
          ),
      },
    ],
  },
  {
    path: "/",
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Public.vue"),
    children: [
      {
        path: "",
        name: "homepage",
        component: () =>
          import(
            /* webpackChunkName: "login" */ "../components/public/HomePage.vue"
          ),
      },
      {
        path: "login",
        name: "login",
        component: () =>
          import(
            /* webpackChunkName: "login" */ "../components/public/Login.vue"
          ),
      },
      {
        path: "lost-password",
        name: "lost-password",
        component: () =>
          import(
            /* webpackChunkName: "lost-password" */ "../components/public/LostPassword.vue"
          ),
      },
      {
        path: "reset-password/:token",
        name: "reset-password",
        component: () =>
          import(
            /* webpackChunkName: "reset-password" */ "../components/public/ResetPassword.vue"
          ),
      },
      {
        path: "share/:hash",
        name: "share",
        component: () =>
          import(
            /* webpackChunkName: "share" */ "../components/public/Share.vue"
          ),
      },
    ],
  },

  {
    path: "/dashboard",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/Dashboard.vue"),
    children: [
      {
        path: "",
        name: "dashboard",
        component: Settings,
      },
      {
        path: "rivers",
        name: "dashboard-rivers",
        component: DashboardRivers,
      },
      {
        path: "pricing",
        name: "dashboard-pricing",
        component: Pricing,
      },
      {
        path: "discounts",
        name: "dashboard-discounts",
        component: Discounts,
      },
      {
        path: "price-groups",
        name: "dashboard-price-groups",
        component: PriceGroups,
      },
      {
        path: "pending-orders",
        name: "dashboard-pending-orders",
        component: PendingOrders,
      },

      {
        path: "reports/full",
        name: "reports-full",
        component: Full,
      },
      {
        path: "reports/closing",
        name: "reports-closing",
        component: Closing,
      },

      {
        path: "order-detail/:orderId",
        name: "dashboard-order",
        component: OrderDetail,
      },
      {
        path: "display-groups",
        name: "dashboard-display-groups",
        component: DisplayGroups,
      },
      {
        path: "users",
        name: "dashboard-users",
        component: DashboardUsers,
      },
      {
        path: "slideshows",
        name: "dashboard-slideshows",
        component: Slideshows,
      },
    ],
  },
  {
    path: "/admin",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/Admin.vue"),
    children: [
      {
        path: "/users",
        name: "admin-users",
        component: Users,
      },
      {
        path: "",
        name: "admin",
        component: Outfitters,
      },
      {
        path: "/rivers",
        name: "admin-rivers",
        component: Rivers,
      },
      {
        path: "/river-sections",
        name: "admin-river-sections",
        component: RiverSections,
      },
      {
        path: "/albums",
        name: "admin-albums",
        component: Albums,
      },
      {
        path: "/orders",
        name: "admin-orders",
        component: Orders,
      },
      {
        path: "/report-photographer",
        name: "admin-report-photographer",
        component: Photographer,
      },
      {
        path: "/report-comprehensive",
        name: "admin-report-comprehensive",
        component: Comprehensive,
      },
    ],
  },
  {
    path: "/photographer/:albumId?",
    beforeEnter: ifAuthenticated,
    name: "photographer",
    component: () =>
      import(
        /* webpackChunkName: "photographer" */ "../views/Photographer.vue"
      ),
  },

  {
    path: "/outfitter/:slug/:external?",
    component: () =>
      import(/* webpackChunkName: "outfitter" */ "../views/Outfitter.vue"),
    children: [
      {
        path: "",
        name: "outfitter",
        component: Search,
      },
    ],
  },

  {
    path: "/cart/:slug/:external?",
    component: () => import(/* webpackChunkName: "cart" */ "../views/Cart.vue"),
    children: [
      {
        path: "",
        name: "cart",
        component: Cart,
      },
    ],
  },
  {
    path: "/deliver/:slug",
    component: () =>
      import(/* webpackChunkName: "deliver" */ "../views/Deliver.vue"),
    children: [
      {
        path: "counter",
        name: "counter",
        component: Counter,
      },
      {
        path: "order/:orderHash/:external?",
        name: "order",
        component: Order,
      },
      {
        path: "zip/:orderHash",
        name: "zip",
        component: Zip,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
